import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.mjs?url";

export const initializePdfjsWorker = (): void => {
  if (typeof window !== "undefined") {
    if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    }
  }
};

// モジュール読み込み時に自動的に初期化
initializePdfjsWorker();

export const getPdfjsVersion = (): string => {
  return pdfjsLib.version;
};

export const getPdfjsOptions = () => {
  return {
    verbosity: 0,
  };
};

